import axios from 'axios'
import { API_URL } from '../../config/apiConfig';
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedSeccionfinanzas,
  addingSeccionfinanzas,
  addingSeccionfinanzasFailed,
  editedSeccionfinanzas,
  editingSeccionfinanzas,
  editingSeccionfinanzasFailed,
  foundSeccionfinanzas,
  loadedSeccionfinanzas,
  loadingSeccionfinanzas,
  loadingSeccionfinanzasFailed,
  removedSeccionfinanza,
  removingSeccionfinanza,
  removingSeccionfinanzaFailed,
  searchingSeccionfinanzas,
  searchingSeccionfinanzasFailed,
  SeccionfinanzasAction,
  SeccionfinanzasActionTypes,
  softRemovedSeccionfinanzas,
  softRemovingSeccionfinanzas,
  softRemovingSeccionfinanzasFailed,
} from '../actions/seccionfinanzasActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'


const searchSeccionfinanzasEpic: Epic<SeccionfinanzasAction, SeccionfinanzasAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionfinanzasActionTypes.SEARCH_SECCIONFINANZAS)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/seccionfinanzas/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundSeccionfinanzas(response.data, action.keep)),
        startWith(searchingSeccionfinanzas()),
        catchError(() => of(searchingSeccionfinanzasFailed()))
      )
    })
  )

const loadSeccionfinanzasEpic: Epic<SeccionfinanzasAction, SeccionfinanzasAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(SeccionfinanzasActionTypes.LOAD_SECCIONFINANZAS)),
    switchMap((action) => {
      let url = `${API_URL}/api/seccionfinanzas/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedSeccionfinanzas(response.data)),
        startWith(loadingSeccionfinanzas()),
        catchError(() => of(loadingSeccionfinanzasFailed()))
      )
    })
  )
}

const addSeccionfinanzasEpic: Epic<SeccionfinanzasAction, SeccionfinanzasAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionfinanzasActionTypes.ADD_SECCIONFINANZAS)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/seccionfinanzas/`, data, config)).pipe(
        map((response) => addedSeccionfinanzas(response.data)),
        startWith(addingSeccionfinanzas()),
        catchError((err) => of(addingSeccionfinanzasFailed(err.response)))
      )
    })
  )

const removeSeccionfinanzasEpic: Epic<SeccionfinanzasAction, SeccionfinanzasAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionfinanzasActionTypes.REMOVE_SECCIONFINANZA)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/seccionfinanzas/${action.payload._id}`)).pipe(
        map((response) => removedSeccionfinanza()),
        startWith(removingSeccionfinanza()),
        catchError(() => of(removingSeccionfinanzaFailed()))
      )
    )
  )

const softRemoveSeccionfinanzasEpic: Epic<SeccionfinanzasAction, SeccionfinanzasAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionfinanzasActionTypes.SOFT_REMOVE_SECCIONFINANZAS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/seccionfinanzas/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedSeccionfinanzas(response.data.record)),
        startWith(softRemovingSeccionfinanzas()),
        catchError((err) => of(softRemovingSeccionfinanzasFailed(err.response)))
      )
    )
  )

const editSeccionfinanzasEpic: Epic<SeccionfinanzasAction, SeccionfinanzasAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionfinanzasActionTypes.EDIT_SECCIONFINANZAS)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/seccionfinanzas/${action.payload._id}`, data, config)).pipe(
        map((response) => editedSeccionfinanzas(response.data)),
        startWith(editingSeccionfinanzas()),
        catchError((err) => of(editingSeccionfinanzasFailed(err.response)))
      )
    })
  )

export default combineEpics(
  searchSeccionfinanzasEpic,
  loadSeccionfinanzasEpic,
  addSeccionfinanzasEpic,
  removeSeccionfinanzasEpic,
  softRemoveSeccionfinanzasEpic,
  editSeccionfinanzasEpic
)
